
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5d9b670a!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ArticlePicker.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ArticlePicker.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5d9b670a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ArticlePicker.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/Picker/ArticlePicker.vue
// module id = 139
// module chunks = 0